<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div class="bg-white padding-xl" style="position:relative;">
			<Form ref="formTgSetting" :model="formTgSetting" label-position="right" :label-width="120" label-colon>
				<FormItem label="注册奖励">
					<Input v-model="formTgSetting.zc" maxlength="4" style="width:100px; text-align: right;"></Input> 积分
					<p class="text-grey">
						<Icon type="ios-information-circle-outline" /> 直接发展会员注册时奖励积分数。</p>
				</FormItem>
				<FormItem label="订单提成">
				<table border="1" cellspacing="0" cellpadding="10">
					<thead>
						<tr>
							<th>订单类型</th>
							<th>不含检测费</th>
							<th>包含检测费</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th>检测站</th>
							<td>
								<p class="padding-bottom-sm">一级：<Input v-model="formTgSetting.order.jcz.njcf.yj" maxlength="4" style="width:100px;"></Input>
									%</p>
								<p>二级：<Input v-model="formTgSetting.order.jcz.njcf.ej" maxlength="4" style="width:100px;"></Input> %</p>
							</td>
							<td>
								<p class="padding-bottom-sm">一级：<Input v-model="formTgSetting.order.jcz.jcf.yj" maxlength="4" style="width:100px;"></Input>
									%</p>
								<p>二级：<Input v-model="formTgSetting.order.jcz.jcf.ej" maxlength="4" style="width:100px;"></Input> %</p>
							</td>
						</tr>
						<tr>
							<th>代驾</th>
							<td>
								<p class="padding-bottom-sm">一级：<Input v-model="formTgSetting.order.dj.njcf.yj" maxlength="4" style="width:100px;"></Input>
									%</p>
								<p>二级：<Input v-model="formTgSetting.order.dj.njcf.ej" maxlength="4" style="width:100px;"></Input> %</p>
							</td>
							<td>
								<p class="padding-bottom-sm">一级：<Input v-model="formTgSetting.order.dj.jcf.yj" maxlength="4" style="width:100px;"></Input>
									%</p>
								<p>二级：<Input v-model="formTgSetting.order.dj.jcf.ej" maxlength="4" style="width:100px;"></Input> %</p>
							</td>
						</tr>
						<tr>
							<th>免检</th>
							<td>
								<p class="padding-bottom-sm">一级：<Input v-model="formTgSetting.order.mj.njcf.yj" maxlength="4" style="width:100px;"></Input>
									%</p>
								<p>二级：<Input v-model="formTgSetting.order.mj.njcf.ej" maxlength="4" style="width:100px;"></Input> %</p>
							</td>
							<td>
								<p class="padding-bottom-sm">一级：<Input v-model="formTgSetting.order.mj.jcf.yj" maxlength="4" style="width:100px;"></Input>
									%</p>
								<p>二级：<Input v-model="formTgSetting.order.mj.jcf.ej" maxlength="4" style="width:100px;"></Input> %</p>
							</td>
						</tr>
					</tbody>
				</table>
				</FormItem>
				<Divider></Divider>
				<FormItem>
					<Button type="primary" @click="submitTgSetting('formTgSetting')" :loading="loading">提交保存</Button>
				</FormItem>
			</Form>
			<Spin fix v-if="loading">
				<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
				<div>处理中...</div>
			</Spin>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				formTgSetting: {
					zc: 0,
					order: {
						jcz: {
							njcz:{
								yj: 0,
								ej: 0
							},
							jcz:{
								yj: 0,
								ej: 0
							}
						},
						mj: {
							njcz:{
								yj: 0,
								ej: 0
							},
							jcz:{
								yj: 0,
								ej: 0
							}
						},
						dj: {
							njcz:{
								yj: 0,
								ej: 0
							},
							jcz:{
								yj: 0,
								ej: 0
							}
						}
					}
				}
			};
		},
		methods: {
			loadinfo() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/client/tg/setting.php?a=init').then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.formTgSetting = res.data.data;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			submitTgSetting: function(name) {
				this.loading = true;
				this.$http.post('/server/api/client/tg/setting.php?a=settingup', this.$qs.stringify(this.formTgSetting)).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							this.$Message.success('更新成功!');
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			}
		},
		created() {
			//console.log(this.searchForm)
			this.loadinfo();
		}
	};
</script>

<style>
	table td,table th{
		padding: 20px;
	}
	table th{
		background: #eee;
	}
</style>
